import { jsx as _jsx } from "react/jsx-runtime";
import { withTheme } from '@material-ui/core/styles';
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import styles from './Logo.styles';
export const Logo = ({ classes, theme, square = false, width, }) => (_jsx("img", { className: cn(classes.root, square && classes.square), src: square ? theme.logo.squareSrc : theme.logo.src, style: { width } }, square ? 'logo-square' : 'logo'));
export default withStyles(styles)(withTheme(Logo));
//# sourceMappingURL=Logo.js.map